import { render, staticRenderFns } from "./uploadImgs2.vue?vue&type=template&id=4cd684dd&scoped=true&"
import script from "./uploadImgs2.vue?vue&type=script&lang=js&"
export * from "./uploadImgs2.vue?vue&type=script&lang=js&"
import style0 from "./uploadImgs2.vue?vue&type=style&index=0&id=4cd684dd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd684dd",
  null
  
)

export default component.exports